<template><div></div></template>

<script>
import Auth from "../apis/Auth";
export default {
  created() {
    Auth.socialLogin(this.$route.params.provider)
      .then(() => {
        this.$root.$emit("after-login");
        this.$router.push({ path: "/instances" });
      })
      .catch((error) => {
        if (error.response.data.error_type === "account_already_exists") {
          this.$router.push({ path: "/login", query: { account_already_exists: true } });
          return;
        }

        this.$router.push({ path: "/login" });
      });
  },
};
</script>
